export const validateGithublink = (val) => {
  const githubUrlRegex =
    /^(https?:\/\/)?(www\.)?github\.com\/[a-zA-Z0-9-_]+\/[a-zA-Z0-9-_]+\/?(\?.*)?(#.*)?$/;

  return githubUrlRegex.test(val);
};
